import React from 'react';
import './style.scss';
import CarouselWithInformativeCardsSlide from '../slide/index.js';
import clsx from 'clsx';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const CarouselWithInformativeCardsGrid = ({ className, colors, ...props }) => {
  const { fields, params } = props;
  const { heading, text } = fields;
  const light = params?.theme !== 'darkMode';
  const needHeading = !!heading?.value;
  const needText = !!text?.value;

  return (
    <div className={clsx('cwic-grid-wrapper', !light && 'cwic-grid-wrapper-dark', className)}>
      <div className={clsx('content', 'cwic-grid')}>
        {(needHeading || needText) && (
          <div className="cwic-grid-header">
            {needHeading && (
              <h3 className="cwic-grid-header-title">
                <Text field={heading} />
              </h3>
            )}
            {needText && <RichText field={text} className="cwic-grid-header-desc" />}
          </div>
        )}
        <div className="row">
          {fields?.items?.map((card, index) => (
            <div className="col-xl-3 col-lg-4 col-md-6 cwic-grid-card" key={index}>
              <CarouselWithInformativeCardsSlide data={card} color={colors[index]} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarouselWithInformativeCardsGrid;
